import * as React from 'react'
import { Col } from 'antd'
import classNames from 'classnames'
import { compose, Dispatch } from 'redux'
import { connect } from 'react-redux'
import { isMobile } from 'react-device-detect'
import { RouteComponentProps, withRouter } from 'react-router'
import styles from './AppFooter.module.scss'
import Container from '../../components/Container'
import CourierDetails from '../../components/CourierDetails/CourierDetails'
import DeliveryDetails from '../../components/DeliveryDetails/DeliveryDetails'
import { DeliveryTrackingData } from '../../store/DeliveryTracking/types'
import { ApplicationState } from '../../store'
import PoweredBy from '../../components/PoweredBy/PoweredBy'
import { FadingView, FadingViewChild } from '../../components/FadingView/FadingView'
import TermsAndConditionsLink from '../../components/TermsAndConditionsLink/TermsAndConditionsLink'

class AppFooter extends React.Component<AllProps, {}> {
  render() {
    const {
      deliveryData: {
        courier,
        dropOffLocation,
        displayIdentifier,
        companyInfo,
        vendor,
        status,
        country,
        downloadButtonEnabled,
      },
      showReschedule,
      rescheduleRequested,
      loading,
      location,
    } = this.props
    const vendorName = vendor.name
    const companyName = companyInfo.displayName

    const detailsClasses: any = {}
    detailsClasses[styles.deliveryDetails] = true
    detailsClasses[styles.mobile] = isMobile
    const isRatingPage = location.pathname.indexOf('/rating/') > -1

    return (
      <div>
        {!isRatingPage && (
          <FadingView pose={!loading && !showReschedule && !rescheduleRequested ? 'visible' : 'hidden'}>
            <FadingViewChild>
              <Container>
                <Col xs={24} className={styles.courierDetails}>
                  <CourierDetails
                    courier={courier}
                    deliveryStatus={status}
                    color={companyInfo.template.primaryColor} />
                </Col>
              </Container>
            </FadingViewChild>
            <FadingViewChild>
              <Container>
                <Col xs={24} className={classNames(detailsClasses)}>
                  <DeliveryDetails
                    displayIdentifier={displayIdentifier}
                    dropOff={dropOffLocation}
                    from={vendorName || companyName} />
                </Col>
              </Container>
            </FadingViewChild>
          </FadingView>
        )}
        <div className={styles.poweredByContainer}>
          <Container>
            <Col xs={24}>
              <PoweredBy {...{ downloadButtonEnabled }} />
            </Col>
            <Col xs={24}>
              <TermsAndConditionsLink country={country} />
            </Col>
          </Container>
        </div>
      </div>
    )
  }
}

interface PropsFromState {
  deliveryData: DeliveryTrackingData
  showReschedule: boolean
  rescheduleRequested: boolean
  loading: boolean
}

interface PropsFromDispatch {

}

type AllProps = PropsFromState & PropsFromDispatch & RouteComponentProps<any>

const mapStateToProps = ({ containers }: ApplicationState) => ({
  deliveryData: containers.DeliveryTracking.deliveryData,
  showReschedule: containers.DeliveryTracking.showReschedule,
  rescheduleRequested: containers.DeliveryTracking.rescheduleRequested,
  loading: containers.DeliveryTracking.loading,
})

const mapDispatchToProps = (dispatch: Dispatch) => ({

})

export default compose<React.ComponentType>(
  connect(mapStateToProps, mapDispatchToProps),
  withRouter,
)(AppFooter)
